import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export interface EsignPrefillRole {
  roleName: string;
  displayName: string;
  /** From the template (authored in the provider's edit view). */
  routingOrder: number;
  /** Best-effort suggestions resolved from workflow context; absent = empty slot. */
  name?: string;
  email?: string;
}

export interface EsignTemplateTaskPrefill {
  mode: 'template';
  signatureTemplateId: string;
  templateName: string;
  roles: EsignPrefillRole[];
}

export interface EsignAdHocTaskPrefill {
  mode: 'ad_hoc';
  /** The document the step's upstream generating step produced. Absent = the assignee supplies one. */
  sourceDocument?: { fileId: number; fileName: string };
}

export type EsignTaskPrefill = EsignTemplateTaskPrefill | EsignAdHocTaskPrefill;

/** What the task UI needs to open a HUMAN_ESIGN task: signer roles in template mode, the default document in ad-hoc. */
export const useEsignTaskPrefill = (serviceRequestTaskId: number | null) => {
  const { data, error, mutate } = useSWR<EsignTaskPrefill>(
    serviceRequestTaskId != null
      ? `e-signature/tasks/${serviceRequestTaskId}/prefill`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    prefill: data,
    error,
    mutate,
    isLoading: serviceRequestTaskId != null && !data && !error,
  };
};
